export function truncateString(originalString: string, maxLength: number): string {
    if (originalString.length <= maxLength) {
      return originalString;
    } else {
      return originalString.slice(0, maxLength) + '';
    }
  }